import Doars from './DoarsInterpret.js'

window.Doars = Doars
